import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';
import Login from './components/Login';
import Home from './components/Home';
import Controls from './components/Controls';
import ChatWidget from './components/ChatWidget';
import { hasAccess, initializeUserAccess } from './config/accessControl';

function App() {
  const [userEmail, setUserEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, isAuthLoading] = useAuthState(auth);

  useEffect(() => {
    // Wait for authentication to complete before initializing
    if (!isAuthLoading && user) {
      const initializeDB = async () => {
        try {
          // Only initialize if we have a logged in user
          console.log('Initializing database with user:', user.email);
          await initializeUserAccess();
        } catch (error) {
          console.error('Error initializing database:', error);
        }
      };

      initializeDB();
    }
  }, [isAuthLoading, user]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUserEmail(user?.email || null);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading || isAuthLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="relative min-h-screen">
        <Routes>
          <Route path="/login" element={
            userEmail ? <Navigate to="/" /> : <Login />
          } />
          <Route path="/" element={
            userEmail ? 
              hasAccess(userEmail) ? <Home /> : 
              <div className="p-4">
                <h1>Access Denied</h1>
                <p>You don't have access to this application.</p>
              </div>
            : <Navigate to="/login" />
          } />
          <Route path="/controls" element={
            userEmail ? 
              hasAccess(userEmail) ? <Controls userEmail={userEmail} /> :
              <div className="p-4">
                <h1>Access Denied</h1>
                <p>You don't have access to this application.</p>
              </div>
            : <Navigate to="/login" />
          } />
        </Routes>

        {/* ChatWidget will persist across all routes when user is logged in */}
        {userEmail && <ChatWidget userEmail={userEmail} />}
      </div>
    </Router>
  );
}

export default App;
